export const statusMeta = {
  not_required: { label: "Not required", tone: "neutral" },
  required: { label: "Pending", tone: "warning" },
  pending: { label: "Pending", tone: "warning" },
  not_started: { label: "Pending", tone: "warning" },
  in_progress: { label: "Pending", tone: "warning" },
  submitted: { label: "Pending", tone: "warning" },
  processing: { label: "Pending", tone: "warning" },
  syncing: { label: "Updating", tone: "warning" },
  sync_delayed: { label: "Sync delayed", tone: "warning" },
  verified: { label: "Approved", tone: "success" },
  review: { label: "Needs review", tone: "warning" },
  approved: { label: "Approved", tone: "success" },
  declined: { label: "Declined", tone: "danger" },
  failed: { label: "Failed", tone: "danger" },
  expired: { label: "Expired", tone: "danger" },
  cancelled: { label: "Cancelled", tone: "danger" },
};

const badgeLabels = {
  not_required: "ID Not Required",
  required: "ID Pending",
  pending: "ID Pending",
  not_started: "ID Pending",
  in_progress: "ID Pending",
  submitted: "ID Pending",
  processing: "ID Pending",
  syncing: "ID Updating",
  sync_delayed: "ID Sync Delayed",
  verified: "ID Approved",
  review: "ID Needs Review",
  approved: "ID Approved",
  declined: "ID Declined",
  failed: "ID Failed",
  expired: "ID Expired",
  cancelled: "ID Cancelled",
};

export const badgeStatusMeta = Object.keys(statusMeta).reduce(
  (meta, status) => ({
    ...meta,
    [status]: {
      ...statusMeta[status],
      label: badgeLabels[status],
    },
  }),
  {},
);

export const normalizeStatus = (value) => {
  const raw = String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  const aliases = {
    need_review: "review",
    needs_review: "review",
    under_review: "review",
    not_needed: "not_required",
    verification_required: "required",
  };

  return aliases[raw] || raw || "not_required";
};

export const getVerificationTooltip = (status) => {
  const normalized = normalizeStatus(status);
  const meta = statusMeta[normalized] || statusMeta.not_required;
  return `ID Verification: ${meta.label}`;
};

// UIkit parses uk-tooltip values with ":" as option pairs, so plain text like
// "ID Verification: Pending" would not set title. Use explicit title: syntax.
export const getVerificationTooltipAttr = (status) => {
  const title = getVerificationTooltip(status);
  return `title: ${title}; pos: top;`;
};

export const getReservationStatus = (reservation, status) =>
  normalizeStatus(
      status?.identity_verification?.status ||
      status?.verification_status ||
      reservation?.verification_status ||
      reservation?.identity_verification?.status ||
      (reservation?.identity_verification_required ? "required" : "not_required"),
  );
